<template>
    <div class="knowledge-list-sidebar-section">
        <!-- 9学知识/疾病库 -->
        <van-list class="knowledge-list-sidebar-section-box">
            <van-cell
                is-link
                class="knowledge-list-sidebar-section-title"
                @click="goDetail(dataItem)"
                :title="dataItem.content.title"
            />
        </van-list>
        <div class="knowledge-list-sidebar-section-zl">
            <span>疾病库</span>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
      searchText: {
        type: String,
        default: ''
      }
    },
  methods: {
    goDetail(dataItem) {
      this.$router.push({ name: 'knowledge-list', params: { id: dataItem.content.id } })
      Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
      Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
.knowledge-list-sidebar-section {
    background-color: #ffffff;
    margin: 10px 10px;
    height: 85vh;
    overflow-y: scroll;

    position: relative;
    height: auto;
    border-radius: 10px;

    &-title {
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 500;
        // i{}
    }

    .van-cell::after {
        border-bottom-width: 0px;
    }
    &-zl {
        position: absolute;
        top: 14px;
        left: 12px;
        background: #10c3b5;
        border-radius: 3px;
        font-family: PingFangSC-Medium;
        font-size: 11px;
        color: #ffffff;
        letter-spacing: 0;
        padding: 1px 6px;
    }
    &-title {
        padding-left: 70px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/knowledge.vue